export const TEST_ROWS = [
  { id: 1, left: { form: "CBC", label: "CBC" }, right: { form: "TSH", label: "TSH" } },
  { id: 3, left: { form: "Urea", label: "Urea" }, right: { form: "FT3", label: "FT3" } },
  { id: 5, left: { form: "Creatinin", label: "Creatinin" }, right: { form: "FT4", label: "FT4" } },
  { id: 7, left: { form: "Bleeding Time", label: "Bleeding Time" }, right: { form: "Suger", label: "Suger" } },
  { id: 9, left: { form: "Clotting Time", label: "Clotting Time" }, right: { form: "HbA1c", label: "HbA1c" } },
  { id: 11, left: { form: "Viral Screen", label: "Viral Screen" }, right: { form: "PT , INR", label: "PT , INR" } },
  { id: 13, left: { form: "Blood Group", label: "Blood Group" }, right: { form: "PTT", label: "PTT" } },
];

export const TEST_FIELDS = TEST_ROWS.flatMap((row) => [row.left, row.right]);

export const EMPTY_TYPES = TEST_ROWS.map((row) => ({
  id: row.id,
  name1: row.left.label,
  check1: false,
  check2: false,
  name2: row.right.label,
}));

export function typesFromChecks(checks = {}) {
  return TEST_ROWS.map((row) => ({
    id: row.id,
    name1: row.left.label,
    check1: !!checks[row.left.form],
    check2: !!checks[row.right.form],
    name2: row.right.label,
  }));
}

export function labPayloadFromChecks(checks = {}) {
  return {
    cbc: !!checks.CBC,
    tsh: !!checks.TSH,
    urea: !!checks.Urea,
    ft3: !!checks.FT3,
    creatinin: !!checks.Creatinin,
    ft4: !!checks.FT4,
    bleedingTime: !!checks["Bleeding Time"],
    suger: !!checks.Suger,
    clottingTime: !!checks["Clotting Time"],
    hba1c: !!checks.HbA1c,
    viralScreen: !!checks["Viral Screen"],
    ptInr: !!checks["PT , INR"],
    bloodGroup: !!checks["Blood Group"],
    ptt: !!checks.PTT,
  };
}

export function selectedTestCount(checks = {}) {
  return TEST_FIELDS.filter((field) => !!checks[field.form]).length;
}

export function checksFromApi(item = {}) {
  return {
    CBC: !!item.cbc,
    TSH: !!item.tsh,
    Urea: !!item.urea,
    FT3: !!item.ft3,
    Creatinin: !!item.creatinin,
    FT4: !!item.ft4,
    "Bleeding Time": !!item.bleedingTime,
    Suger: !!item.suger,
    "Clotting Time": !!item.clottingTime,
    HbA1c: !!item.hba1c,
    "Viral Screen": !!item.viralScreen,
    "PT , INR": !!(item.ptInr || item.pt),
    "Blood Group": !!item.bloodGroup,
    PTT: !!item.ptt,
  };
}

export function typesFromApi(item = {}) {
  return typesFromChecks(checksFromApi(item));
}

export function testCountFromApi(item = {}) {
  return selectedTestCount(checksFromApi(item));
}

export function selectedTestLabels(checks = {}) {
  return TEST_FIELDS.filter((field) => !!checks[field.form]).map((field) => field.label);
}
